// When we send the user to the native notification settings, we keep listening
// until they come back. Act only once the permission has reached the state they
// went there to change: the check also fires while we navigate away, when the
// permission still holds its pre-change value, and that must fall through.
type PushSettingsDirection = 'enable' | 'disable';

export const pushSettingsReturnAction = ({
  direction,
  permissionGranted,
}: {
  direction: PushSettingsDirection | null;
  permissionGranted: boolean;
}): PushSettingsDirection | 'wait' => {
  if (direction === 'enable' && permissionGranted) {
    return 'enable';
  }
  if (direction === 'disable' && !permissionGranted) {
    return 'disable';
  }
  return 'wait';
};
